export const CACHE_KEY_AGENCY_LOOKUPS = 'CD_PROFILE_LOOKUPS_V1';

export const LOOKUP_MAPPING = {
    countryOfResidence: 'countryOfResidence',
    specialization: 'jobTalent', // Assuming specialization maps to jobTalent
    addressType: 'addressType',
    pocDesignation: 'pocDesignation',
    pocContactType: 'contactType'
};

// --- REGEX PATTERNS ---
export const PAN_REGEX = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/;
export const AADHAR_REGEX = /^[2-9]{1}[0-9]{11}$/;
export const GST_REGEX = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;
export const MOBILE_REGEX = /^[+]?[0-9]{10,15}$/;

export const WIZARD_STEPS_AGENCY_PROFILE = [
    { id: 0, title: 'Company Info', fields: ['yourName', 'email', 'mobileNumber', 'alternateMobileNumber', 'agencyName', 'companyIncorporationDate', 'countryOfResidence', 'specialization', 'aboutAgency', 'gstNumber', 'panNumber', 'aadharNumber'] },
    { id: 1, title: 'Address', fields: ['addressType', 'pinCode', 'addressLine1', 'state', 'district'] },
    // { id: 2, title: 'Team / POC', fields: ['teamMembers'] }, // Validation on teamMembers array
    { id: 2, title: 'Social Media', fields: ['imdUrl','facebookProfileUrl', 'linkedinProfileUrl', 'instagramProfileUrl', 'twitterProfileUrl', 'youtubeUrl', 'whatsappNo'] }
];

// Custom Styles for React-Select (can be global or here)
export const customStyles = {
    control: (p, s) => ({ ...p, backgroundColor: '#212529', borderColor: s.isFocused ? '#b7343a' : '#495057', color: '#fff', minHeight: '45px', boxShadow: s.isFocused ? '0 0 0 1px #b7343a' : 'none', '&:hover': { borderColor: '#b7343a' } }),
    singleValue: (p) => ({ ...p, color: '#fff' }),
    input: (p) => ({ ...p, color: '#fff', margin: 0, padding: 0 }),
    menu: (p) => ({ ...p, backgroundColor: '#212529', zIndex: 9999, border: '1px solid #495057' }),
    option: (p, s) => ({ ...p, backgroundColor: s.isSelected ? '#b7343a' : s.isFocused ? '#343a40' : '#212529', color: '#fff', cursor: 'pointer' }),
    multiValue: (p) => ({ ...p, backgroundColor: '#343a40' }),
    multiValueLabel: (p) => ({ ...p, color: '#fff' }),
    multiValueRemove: (p) => ({ ...p, color: '#fff', ':hover': { backgroundColor: '#b7343a', color: 'white' } }),
};